import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";
import { StyledLabel } from "../../../common/components/InputLabel";

const AttachmentsInput = ({ register, error, helperText }) => {
  return (
    <React.Fragment>
      <Grid item xs={3} sx={{ marginTop: 1 }}>
        <StyledLabel error={error} id="attachments-permitted-label">
          Attachments Permitted
        </StyledLabel>
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </Grid>
      <Grid item xs={9}>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="attachments-permitted-label"
            name="attachmentsPermitted"
          >
            <FormControlLabel
              value={true}
              control={<Radio {...register("attachmentsPermitted")} />}
              label="Yes"
            />
            <FormControlLabel
              value={false}
              control={
                <Radio
                  {...register("attachmentsPermitted")}
                  sx={{ marginLeft: 8 }}
                />
              }
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </React.Fragment>
  );
};

export default AttachmentsInput;
